<div class="white-box mt-4 p-4 border-radius">
	<div class="mb-3 text-right" *ngIf="!DeviceFactory.isChargerDeviceType(device.config_info.sct_device_type) && !isIMDeviceType">
		<div class="custom-control custom-radio custom-control-inline">
			<input
				type="radio"
				id="voltageModeBattery"
				name="eventVoltageMode"
				class="custom-control-input"
				[value]="VOLTAGE_DISPLAY.BATTERY_VOLTAGE"
				[(ngModel)]="voltageDisplayMode.event"
				(ngModelChange)="onVoltageModeChange($event)"
			>
			<label class="custom-control-label" for="voltageModeBattery">{{ 'exception_reports.battery_voltage' | translate }}</label>
		</div>
		<div class="custom-control custom-radio custom-control-inline">
			<input
				type="radio"
				id="voltageModeVpc"
				name="eventVoltageMode"
				class="custom-control-input"
				[value]="VOLTAGE_DISPLAY.VPC"
				[(ngModel)]="voltageDisplayMode.event"
				(ngModelChange)="onVoltageModeChange($event)"
			>
			<label class="custom-control-label" for="voltageModeVpc">{{ 'event.vpc' | translate }}</label>
		</div>
	</div>

	<sct-custom-table
		*ngIf="tablesConfig.event.tableData.length > 0 && tablesConfig.event.hasData"
		[columnsConfig]="tablesConfig.event.columnConfig"
		[data]="tablesConfig.event.tableData"
		[config]="tablesConfig.event.tableConfig"
	></sct-custom-table>

	<div class="text-danger" *ngIf="invalidDateRange; else noData"><b>{{'g.start_lg_end' | translate}}</b></div>
	<ng-template #noData>
		<div *ngIf="events.length == 0">{{'g.no_data_available_for_the_selected_period' | translate}}</div>
	</ng-template>
</div>

<div *ngIf="tablesConfig.offEvent.hasData && showCorruptedEvents" class="white-box mt-4 p-4 border-radius">
	<sct-custom-table
		*ngIf="tablesConfig.offEvent.tableData.length > 0"
		[columnsConfig]="tablesConfig.offEvent.columnConfig"
		[data]="tablesConfig.offEvent.tableData"
		[config]="tablesConfig.offEvent.tableConfig"
	></sct-custom-table>
	<div class="text-danger" *ngIf="invalidDateRange; else noDataCurr"><b>{{'g.start_lg_end' | translate}}</b></div>
	<ng-template #noDataCurr>
		<div *ngIf="!corruptedEvents.length">{{'g.no_data_available_for_the_selected_period' | translate}}</div>
	</ng-template>
</div>

<div *ngIf="tablesConfig.defectiveEvent.hasData && showDefectiveEvents" class="white-box mt-4 p-4 border-radius">
	<div class="mb-3 d-flex justify-content-between align-items-center">
		<h4>{{'g.defective_records' | translate}}</h4>
	</div>
	<sct-custom-table
		*ngIf="tablesConfig.defectiveEvent.tableData.length > 0"
		[columnsConfig]="tablesConfig.defectiveEvent.columnConfig"
		[data]="tablesConfig.defectiveEvent.tableData"
		[config]="tablesConfig.defectiveEvent.tableConfig"
	></sct-custom-table>
	<div class="text-danger" *ngIf="invalidDateRange; else noDataCurr"><b>{{'g.start_lg_end' | translate}}</b></div>
	<ng-template #noDataCurr>
		<div *ngIf="!defectiveEvents.length">{{'g.no_data_available_for_the_selected_period' | translate}}</div>
	</ng-template>
</div>
